module.exports = __webpack_public_path__ + "static/images/checkmark.e42c70474604122332c9dd9203b6cfd5.svg";